<template>
	<el-footer>
		<div class="foot-box">
			<div class="foot-content">
				<!-- 品牌介绍 -->
				<div class="foot-brand-col">
					<div class="footlogobox">
						<h1 class="logo">
							<a href="./">
								<img src="@/assets/images/20260303-132939.png" title="特规通" />
								<span class="foot-brand-name">特规通</span>
							</a>
						</h1>
					</div>
					<p class="foot-brand-desc">
						特种设备行业一站式合规服务平台，提供正版图书商城、AI法规问答、标准关联查询等服务，让合规更简单。
					</p>
					<div class="foot-contact">
						<div class="contact-item">
							<i class="el-icon-message"></i>
							<span>service@teguitong.com</span>
						</div>
						<div class="contact-item">
							<i class="el-icon-phone"></i>
							<span>18911620150</span>
						</div>
					</div>
				</div>

				<div class="menubox">
					<div class="menu-list-box">
						<h3>功能介绍</h3>
						<ul>
							<li>
								<a target="_blank" @click="navigateToInfo({ group: '功能介绍', type: 'content', title: '法规标准库', id: 11 })">
									<el-link>法规标准库</el-link>
								</a>
							</li>
							<li>
								<a target="_blank" @click="navigateToInfo({ group: '功能介绍', type: 'content', title: 'AI-行业大模型', id: 14 })">
									<el-link>AI-行业大模型</el-link>
								</a>
							</li>
							<li>
								<a target="_blank" @click="navigateToInfo({ group: '功能介绍', type: 'content', title: '个人书架', id: 26 })">
									<el-link>个人书架（个人版）</el-link>
								</a>
							</li>
							<li>
								<a target="_blank" @click="navigateToInfo({ group: '功能介绍', type: 'content', title: '企业资料馆', id: 16 })">
									<el-link>企业资料馆（企业版）</el-link>
								</a>
							</li>
							<li>
								<a target="_blank" @click="navigateToInfo({ group: '功能介绍', type: 'content', title: '正版图书购买', id: 15 })">
									<el-link>正版图书购买</el-link>
								</a>
							</li>
							<li>
								<a href="/standardslist.html" target="_blank">
									<el-link>法规标准导航大全</el-link>
								</a>
							</li>
						</ul>
					</div>
					<!-- <div class="menu-list-box">
						<h3>核心服务</h3>
						<ul>
							<li>
								<a target="_blank" @click="handleRoute('/StandardsList')">
									<el-link>正版图书商城</el-link>
								</a>
							</li>
							<li>
								<a target="_blank" @click="handleRoute('/ai')">
									<el-link>AI法规问答</el-link>
								</a>
							</li>
							<li>
								<a target="_blank" @click="handleRoute('/BookCenter/BuyList')">
									<el-link>企业资料管理</el-link>
								</a>
							</li>
						</ul>
					</div> -->
					<div class="menu-list-box">
						<h3>关于我们</h3>
						<ul>
							<li>
								<a @click="navigateToInfo({ group: '关于我们', id: 101, type: 'content', title: '量大信息研究院（平台运营）' })">
									<el-link>平台运营</el-link>
								</a>
							</li>
							<li>
								<a @click="navigateToInfo({ group: '关于我们', id: 103, type: 'content', title: '品读文化（图书销售）' })">
									<el-link>图书销售</el-link>
								</a>
							</li>
							<li>
								<a @click="navigateToInfo({ group: '关于我们', id: 1, type: 'content', title: '用户协议' })">
									<el-link>用户协议</el-link>
								</a>
							</li>
							<li>
								<a @click="navigateToInfo({ group: '关于我们', id: 2, type: 'content', title: '隐私协议' })">
									<el-link>隐私协议</el-link>
								</a>
							</li>
							<li>
								<a @click="navigateToInfo({ group: '关于我们', id: 3, type: 'content', title: '图书销售协议' })">
									<el-link>图书销售协议</el-link>
								</a>
							</li>
							<li>
								<a @click="toGuide">
									<el-link>操作指引</el-link>
								</a>
							</li>
							<li>
								<a @click="toOrderVerify">
									<el-link>正版查验</el-link>
								</a>
							</li>
						</ul>
					</div>
				</div>

				<div class="right-main">
					<h3>关注我们</h3>
					<div class="rightbox">
						<div class="ercodebox">
							<img src="@/assets/images/20251231-144123.jpg" title="二维码" width="80" />
							<div>订阅号</div>
						</div>
						<div class="phonebox">
							<img src="@/assets/images/20251231-144201.jpg" title="二维码" width="80" />
							<div>服务号</div>
						</div>
						<div class="miniprogrambox">
							<div class="miniprogramimg">
								<img src="@/assets/images/miniprogram_code.png" title="二维码" width="75" />
							</div>
							<div>微信小程序</div>
						</div>

						<div class="miniprogrambox">
							<div class="miniprogramimg" style="padding: 4px 3px 0;height: 79px;">
								<img src="@/assets/images/kefu.png" title="二维码" width="75" />
							</div>
							<div>客服微信</div>
						</div>
					</div>
				</div>
			</div>
			<div class="foot-copy">
				<a href="https://beian.miit.gov.cn/#/Integrated/index" target="_blank">©2025 量大（北京）信息科技研究院有限公司<span>京ICP备2024096922号-3</span></a>
				<a href="https://beian.cac.gov.cn/#/index" target="_blank">网信算备<span>110108235372701260013号</span></a>
				<a style="cursor: pointer" target="_blank" @click="handleClickXKZ">出版物许可证</a>
				<p style="margin-top: 12px; color: #475569;">特种设备法规标准智能服务平台 · 让合规更简单</p>
			</div>
		</div>
	</el-footer>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
export default {
	data() {
		return {
			cbwUrl: require('@/assets/images/20260304-100309.png')
		};
	},
	computed: {
		...mapGetters('User', ['uisLogin'])
	},
	methods: {
		...mapActions('Settings', ['setLoginShow']),
		handleClickXKZ() {
			window.open(this.cbwUrl);
		},

		toGuide() {
			this.$router.push('/guide');
		},

		toOrderVerify() {
			const targetRoute = this.$router.resolve({
				path: '/checker'
			});
			window.open(targetRoute.href, '_blank');
		},
		navigateToInfo(query) {
			if (query.type == 'feedBack') {
				if (!this.uisLogin) {
					this.setLoginShow(true);
					return;
				}
			}
			const targetRoute = this.$router.resolve({
				path: '/info',
				query
			});
			window.open(targetRoute.href, '_blank');
		},

		handleRoute(href){
			if(href === '/BookCenter/BuyList') {
				if(!this.uisLogin) {
					this.setLoginShow(true);
				}else {
					this.$router.push(href);
				}
			}else {
				this.$router.push(href);
			}
		}
	}
};
</script>

<style lang="less" scoped>
// ========== Footer 样式 - 匹配 lz_project ==========
.el-footer {
	height: auto !important;
	color: #94a3b8;
	background-color: #0f172a;
	padding: 0;
}

.foot-box {
	width: 100%;
	max-width: 1280px;
	margin: 0 auto;
	padding: 60px 24px 40px;
	box-sizing: border-box;
}

.footlogobox {
	display: flex;
	align-items: center;
	gap: 10px;
	margin-bottom: 16px;
}

.logo {
	margin: 0;
	display: flex;
	align-items: center;
	gap: 10px;

	a {
		display: flex;
		align-items: center;
		gap: 10px;
		text-decoration: none;
		color: #ffffff;

		img {
			width: 40px;
			height: 40px;
			border-radius: 12px;
			// background: linear-gradient(135deg, #3b82f6, #6366f1);
			padding: 6px;
			box-sizing: border-box;
		}
	}
}

.foot-brand-name {
	font-size: 20px;
	font-weight: 700;
	color: #ffffff;
}

.foot-brand-desc {
	color: #94a3b8;
	font-size: 14px;
	line-height: 1.7;
	margin: 0 0 20px;
	max-width: 360px;
}

.foot-contact {
	.contact-item {
		display: flex;
		align-items: center;
		gap: 8px;
		font-size: 13px;
		color: #94a3b8;
		margin-bottom: 6px;

		i {
			font-size: 14px;
			color: #64748b;
		}
	}
}

.foot-content {
	display: flex;
	justify-content: space-between;
	padding-bottom: 40px;
	border-bottom: 1px solid #1e293b;
	gap: 40px;
}

.foot-brand-col {
	// flex: 2;
	min-width: 0;
}

.menubox {
	display: flex;
	justify-content: space-between;
	flex: 2;
	gap: 20px;
}

.menu-list-box {
	flex: 1;
	min-width: 120px;

	h3 {
		margin: 0 0 16px;
		font-size: 16px;
		color: #ffffff;
		font-weight: 600;
	}

	ul {
		margin: 0;
		padding: 0;
		list-style: none;
	}

	li {
		list-style-type: none;
		margin-bottom: 8px;

		a {
			text-decoration: none;
			color: #94a3b8;
			font-size: 14px;
			transition: color 0.2s;

			&:hover {
				color: #ffffff;
			}
		}
	}
}

.link-us-box {
	li {
		.el-link {
			color: #94a3b8;
			font-size: 14px;

			&:hover {
				color: #cbd5e1;
			}
		}
	}
}

.right-main {
	// flex: 1;
	// min-width: 220px;
	width: 220px;

	h3 {
		margin: 0 0 16px;
		font-size: 16px;
		color: #ffffff;
		font-weight: 600;
	}
}

.rightbox {
	display: flex;
	gap: 16px;
	flex-wrap: wrap;
}

.ercodebox,
.phonebox,
.miniprogrambox {
	display: flex;
	flex-direction: column;
	align-items: center;
	font-size: 12px;
	color: #64748b;

	img {
		margin-bottom: 8px;
		border-radius: 8px;
	}
}

.miniprogrambox {
	.miniprogramimg {
		background: #fff;
		padding: 3px 3px 0px;
		border-radius: 8px;
		margin-bottom: 8px;

		img {
			margin-bottom: 0;
		}
	}
}

.foot-copy {
	margin-top: 28px;
	font-size: 13px;
	color: #64748b;
	text-align: center;

	a {
		color: #64748b;
		text-decoration: none;
		transition: color 0.2s;

		&:hover {
			color: #94a3b8;
		}

		& {
			margin-right: 16px;
		}
	}
}

/deep/ .el-link.el-link--default {
	margin: 0;
	color: #94a3b8;
	text-decoration: none;
	font-size: 14px;
}

/deep/ .el-link.is-underline:hover:after {
	border-bottom: 1px solid transparent;
}

.menu-list-box a:hover {
	color: #ffffff;
}

// ========== 响应式 ==========
@media screen and (max-width: 767px) {
	.foot-box {
		padding: 40px 16px 30px;
	}

	.foot-content {
		flex-direction: column;
		gap: 30px;
	}

	.menubox {
		flex-wrap: wrap;
		gap: 20px;
	}

	.menu-list-box {
		flex: 0 0 calc(50% - 10px);
		min-width: 0;
	}

	.rightbox {
		justify-content: flex-start;
	}
}

@media screen and (min-width: 768px) and (max-width: 1024px) {
	.foot-box {
		padding: 50px 20px 35px;
	}

	.foot-content {
		flex-direction: column;
		gap: 30px;
	}

	.menubox {
		gap: 16px;
	}

	.rightbox {
		justify-content: flex-start;
	}
}
</style>
